import { Box, Typo } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../../organisms/trans'

export interface FormFooterProps {
  tName?: string
  tKey: TKeyBuilder
  t: TFunction
}

export const FormFooter: FunctionComponent<FormFooterProps> = ({ t, tKey, tName }) => {
  const { i18n } = useTranslation()

  return tName && i18n.exists(tKey('footer')) ? (
    <Box>
      <Typo as='pre' typoSize='sm' color='bodySecondary'>
        <WriskTrans t={t} i18nKey={tKey('footer')} />
      </Typo>
    </Box>
  ) : null
}
